import { CommitmentsCommandsService_commitmentCommandsServiceGetEntity } from '@festina/life-general-types/life/hooks/CommitmentsCommandsService_commitmentCommandsServiceGetEntity'

export const useFetchLifeCommandById =
  CommitmentsCommandsService_commitmentCommandsServiceGetEntity.useSuspenseQuery
